import React from "react";
import { useDispatch } from "react-redux";
import { setIsInviteModalOpen } from "../../../../reducers/invite-reducer";
import { isInviteParticipantButtonVisible } from "./inviteParticipantUtils";
import useLanguageChange from "../../../../hooks/useLanguageChange";

export const InviteParticipantIconButton = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();

    return (
        <>
            {isInviteParticipantButtonVisible() && (
                <div className='topbar-button' onClick={() => dispatch(setIsInviteModalOpen(true))} onKeyDown={() => {}}>
                    <div className='button custom-tooltip tooltip-auto-width m-hide'>
                        <button className='btn topbar-btn' data-bs-target='#invite-participant-modal'>
                            <span className='for-icon icon-invite-user'></span>
                        </button>
                        <div className='custom-tooltip-content text-nowrap'>
                            <div className='custom-tooltip-in'>
                                <p>{localisedValues["invite_participant_lable"]}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export const InviteParticipantButton = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();

    return (
        <>
            {isInviteParticipantButtonVisible("more") && (
                <div className='action-button'>
                    <div className='action-button-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width'>
                        <button className='call-action-btn' onClick={() => dispatch(setIsInviteModalOpen(true))}>
                            <span className='action-button-icon'>
                                <span className='for-icon icon-invite-user'></span>
                            </span>
                            <span className='for-text'>{localisedValues?.invite_participant_lable}</span>
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};
